<template>
    <ReactPage>
      <daily-login-report-page></daily-login-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "DailyLoginReport",
    components: {
      ReactPage
    }
  }
  </script>